module.exports = __webpack_public_path__ + "img/titleTxt.08e4743e.png";